import { Children, Fragment, cloneElement } from "react";
function flattenChildren(children, options = {}) {
  const { keyPrefix } = options;
  return Children.toArray(children).reduce((flatChildren, child) => {
    const key = keyPrefix ? `${keyPrefix})_${child.key}` : child.key;
    if (child.type === Fragment) {
      return flatChildren.concat(
        flattenChildren(child.props.children, {
          keyPrefix: key
        })
      );
    }
    flatChildren.push(
      typeof child === "object" ? cloneElement(child, { key }) : child
    );
    return flatChildren;
  }, []);
}
export {
  flattenChildren
};
